// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.music-details-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 250px;
  padding: 10px;
  max-width: 1200px;
  width: 100%;
}
.music-details-card .thumbnail-box {
  max-width: 100%;
  position: relative;
  height: 200px;
  /* Video tab-specific thumbnail styles */
  /* Separate content and buttons for the video tab */
  /* Separate content and buttons for the music tab */
}
.music-details-card .thumbnail-box img {
  width: 100%;
  height: 100%;
  border-radius: 16px;
  object-fit: cover;
  transition: transform 0.5s ease, filter 0.5s ease;
  transform-origin: left center; /* Scale from the left initially */
}
.music-details-card .thumbnail-box.video-active img {
  filter: brightness(40%) blur(5px); /* Only apply blur to image */
  transform: scale(1.5); /* Enlarge the thumbnail */
}
.music-details-card .thumbnail-box .listen-count {
  margin-top: 8px;
  color: #fff;
  text-align: center;
  font-size: 14px;
}
.music-details-card .thumbnail-box .video-content {
  display: flex;
  top: 40%; /* Adjust positioning for video content */
  left: 30%; /* Adjust left positioning for video content */
  transform: translateY(-50%);
  z-index: 1;
  text-align: center;
  color: white;
}
.music-details-card .thumbnail-box .video-content .content-box .title-with-icon {
  display: inline-flex;
  align-items: center;
  font-weight: 700;
  font-size: 10px !important; /* Adjust text size for video tab */
  margin-bottom: 10px;
  text-align: center;
}
.music-details-card .thumbnail-box .video-content .content-box .title-with-icon img {
  margin-left: 30px;
  height: 30px; /* Adjust icon size for video tab */
}
.music-details-card .thumbnail-box .video-content .content-box .playlist-info {
  display: flex;
  gap: 10px;
  margin-top: 5px;
  font-family: "Inter";
  font-size: 12px; /* Adjust font size for video tab */
  font-weight: 600;
  align-items: center;
}
.music-details-card .thumbnail-box .video-content .content-box .playlist-info .song-count {
  margin-right: 4px;
}
.music-details-card .thumbnail-box .video-content .content-box .playlist-info .duration {
  font-weight: 300;
}
.music-details-card .thumbnail-box .video-content .content-box .uploader-info {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.music-details-card .thumbnail-box .video-content .content-box .uploader-info .uploader-name {
  margin-left: 1px;
  font-size: 12px;
  color: white;
}
.music-details-card .thumbnail-box .video-content .actions-row {
  margin-top: 15px;
  display: flex;
  gap: 5px;
  z-index: 1;
  align-items: center;
}
.music-details-card .thumbnail-box .video-content .actions-row .Music-button, .music-details-card .thumbnail-box .video-content .actions-row .Video-button, .music-details-card .thumbnail-box .video-content .actions-row .share-button, .music-details-card .thumbnail-box .video-content .actions-row .tip-button, .music-details-card .thumbnail-box .video-content .actions-row .analytics-button {
  width: 20px; /* Smaller button size for video tab */
  height: 20px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.music-details-card .thumbnail-box .video-content .actions-row .Music-button img, .music-details-card .thumbnail-box .video-content .actions-row .Video-button img, .music-details-card .thumbnail-box .video-content .actions-row .share-button img, .music-details-card .thumbnail-box .video-content .actions-row .tip-button img, .music-details-card .thumbnail-box .video-content .actions-row .analytics-button img {
  width: 15px;
  height: 15px; /* Smaller icon size for video tab */
}
.music-details-card .thumbnail-box .video-content .actions-row .Music-button:hover, .music-details-card .thumbnail-box .video-content .actions-row .Video-button:hover, .music-details-card .thumbnail-box .video-content .actions-row .share-button:hover, .music-details-card .thumbnail-box .video-content .actions-row .tip-button:hover, .music-details-card .thumbnail-box .video-content .actions-row .analytics-button:hover {
  background-color: rgba(255, 255, 255, 0.3);
}
.music-details-card .thumbnail-box .music-content {
  position: absolute;
  top: 50%; /* Default positioning for music content */
  left: 10%; /* Default left positioning for music content */
  transform: translateY(-50%);
  z-index: 1;
  text-align: left;
  color: white;
}
.music-details-card .thumbnail-box .music-content .content-box .title-with-icon {
  display: inline-flex;
  align-items: center;
  font-weight: 700;
  font-size: 54px; /* Adjust text size for music tab */
  margin-bottom: 10px;
}
.music-details-card .thumbnail-box .music-content .content-box .title-with-icon img {
  margin-left: 10px;
  height: 40px; /* Default icon size for music tab */
}
.music-details-card .thumbnail-box .music-content .content-box .playlist-info {
  display: flex;
  gap: 10px;
  margin-top: 5px;
  font-family: "Inter";
  font-size: 16px; /* Default font size for music tab */
  font-weight: 600;
}
.music-details-card .thumbnail-box .music-content .content-box .playlist-info .song-count {
  margin-right: 4px;
}
.music-details-card .thumbnail-box .music-content .content-box .playlist-info .duration {
  font-weight: 300;
}
.music-details-card .thumbnail-box .music-content .content-box .uploader-info {
  display: flex;
  align-items: left;
  margin-top: 10px;
}
.music-details-card .thumbnail-box .music-content .content-box .uploader-info .uploader-name {
  margin-left: 5px;
  font-size: 12px;
  color: white;
}
.music-details-card .thumbnail-box .music-content .actions-row {
  margin-top: 20px;
  display: flex;
  gap: 10px;
  z-index: 1;
  align-items: center;
}
.music-details-card .thumbnail-box .music-content .actions-row .Music-button, .music-details-card .thumbnail-box .music-content .actions-row .Video-button, .music-details-card .thumbnail-box .music-content .actions-row .share-button, .music-details-card .thumbnail-box .music-content .actions-row .tip-button, .music-details-card .thumbnail-box .music-content .actions-row .analytics-button {
  width: 40px; /* Default button size for music tab */
  height: 40px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.music-details-card .thumbnail-box .music-content .actions-row .Music-button img, .music-details-card .thumbnail-box .music-content .actions-row .Video-button img, .music-details-card .thumbnail-box .music-content .actions-row .share-button img, .music-details-card .thumbnail-box .music-content .actions-row .tip-button img, .music-details-card .thumbnail-box .music-content .actions-row .analytics-button img {
  width: 20px;
  height: 20px; /* Default icon size for music tab */
}
.music-details-card .thumbnail-box .music-content .actions-row .Music-button:hover, .music-details-card .thumbnail-box .music-content .actions-row .Video-button:hover, .music-details-card .thumbnail-box .music-content .actions-row .share-button:hover, .music-details-card .thumbnail-box .music-content .actions-row .tip-button:hover, .music-details-card .thumbnail-box .music-content .actions-row .analytics-button:hover {
  background-color: rgba(255, 255, 255, 0.3);
}
.music-details-card .tipper-streamer-section {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 250px;
  margin-left: auto;
  margin-top: 0;
}
.music-details-card .tipper-streamer-section ._playlist_topfive_dropdown_container {
  margin: 0;
  background-color: rgba(0, 0, 0, 0.6);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  opacity: 0.95;
  z-index: 1;
}
.music-details-card .tipper-streamer-section .tipper-card, .music-details-card .tipper-streamer-section .streamer-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 7px;
  border-radius: 10px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  width: 250px;
}
.music-details-card .tipper-streamer-section .tipper-card .avatar, .music-details-card .tipper-streamer-section .streamer-card .avatar {
  width: 30px;
  height: 30px;
}
.music-details-card .tipper-streamer-section .tipper-card .name, .music-details-card .tipper-streamer-section .streamer-card .name {
  color: #fff;
  cursor: pointer;
}
.music-details-card .tipper-streamer-section .tipper-card .name:hover, .music-details-card .tipper-streamer-section .streamer-card .name:hover {
  text-decoration: underline;
}
.music-details-card .tipper-streamer-section .tipper-card .amount, .music-details-card .tipper-streamer-section .streamer-card .amount {
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}
.music-details-card .tipper-streamer-section .tipper-streamer-list {
  max-height: 2%;
  overflow-y: auto;
  width: fit-content;
  align-items: flex-end;
}
.music-details-card .tipper-streamer-section .no-data-message {
  color: #fff;
  font-size: 14px;
}
@media (max-width: 768px) {
  .music-details-card {
    flex-direction: column;
  }
  .music-details-card .tipper-streamer-section {
    width: 100%;
    align-items: center;
  }
  .music-details-card .music-content,
  .music-details-card .video-content {
    transform: translateY(-50%);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/MyMusic/MusicDetailsCard.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,iBAAA;EACA,WAAA;AACF;AACE;EACE,eAAA;EACA,kBAAA;EACA,aAAA;EAaA,wCAAA;EAeA,mDAAA;EAoFA,mDAAA;AA5GJ;AADI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,iDAAA;EACA,6BAAA,EAAA,kCAAA;AAGN;AAGM;EACE,iCAAA,EAAA,6BAAA;EACA,qBAAA,EAAA,0BAAA;AADR;AAKI;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AAHN;AAOI;EACA,aAAA;EACE,QAAA,EAAA,yCAAA;EACA,SAAA,EAAA,8CAAA;EACA,2BAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;AALN;AAQQ;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0BAAA,EAAA,mCAAA;EACA,mBAAA;EACA,kBAAA;AANV;AAQU;EACE,iBAAA;EACA,YAAA,EAAA,mCAAA;AANZ;AAUQ;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,oBAAA;EACA,eAAA,EAAA,mCAAA;EACA,gBAAA;EACA,mBAAA;AARV;AAUU;EACE,iBAAA;AARZ;AAWU;EACE,gBAAA;AATZ;AAaQ;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAXV;AAaU;EACE,gBAAA;EACA,eAAA;EACA,YAAA;AAXZ;AAgBM;EACE,gBAAA;EACA,aAAA;EACA,QAAA;EACA,UAAA;EACA,mBAAA;AAdR;AAgBQ;EACE,WAAA,EAAA,sCAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAdV;AAgBU;EACE,WAAA;EACA,YAAA,EAAA,oCAAA;AAdZ;AAiBU;EACE,0CAAA;AAfZ;AAsBI;EACE,kBAAA;EACA,QAAA,EAAA,0CAAA;EACA,SAAA,EAAA,+CAAA;EACA,2BAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;AApBN;AAuBQ;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA,EAAA,mCAAA;EACA,mBAAA;AArBV;AAuBU;EACE,iBAAA;EACA,YAAA,EAAA,oCAAA;AArBZ;AAyBQ;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,oBAAA;EACA,eAAA,EAAA,oCAAA;EACA,gBAAA;AAvBV;AAyBU;EACE,iBAAA;AAvBZ;AA0BU;EACE,gBAAA;AAxBZ;AA4BQ;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;AA1BV;AA4BU;EACE,gBAAA;EACA,eAAA;EACA,YAAA;AA1BZ;AA+BM;EACE,gBAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;AA7BR;AA+BQ;EACE,WAAA,EAAA,sCAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA7BV;AA+BU;EACE,WAAA;EACA,YAAA,EAAA,oCAAA;AA7BZ;AAgCU;EACE,0CAAA;AA9BZ;AAqCE;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;AAnCJ;AAqCI;EACE,SAAA;EACA,oCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,mBAAA;EACA,aAAA;EACA,yCAAA;EACA,0CAAA;EACA,aAAA;EACA,UAAA;AAnCN;AAsCI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,2CAAA;EACA,YAAA;AApCN;AAsCM;EACE,WAAA;EACA,YAAA;AApCR;AAuCM;EACE,WAAA;EACA,eAAA;AArCR;AAuCQ;EACE,0BAAA;AArCV;AAyCM;EACE,WAAA;EACA,eAAA;EACA,gBAAA;AAvCR;AA2CI;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AAzCN;AA4CI;EACE,WAAA;EACA,eAAA;AA1CN;AA8CE;EA9QF;IA+QI,sBAAA;EA3CF;EA6CE;IACE,WAAA;IACA,mBAAA;EA3CJ;EA8CE;;IAEE,2BAAA;EA5CJ;AACF","sourcesContent":[".music-details-card {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 250px;\n  padding: 10px;\n  max-width: 1200px;\n  width: 100%;\n\n  .thumbnail-box {\n    max-width: 100%;\n    position: relative;\n    height: 200px;\n\n\n    img {\n      width: 100%;\n      height: 100%;\n      border-radius: 16px;\n      object-fit: cover;\n      transition: transform 0.5s ease, filter 0.5s ease;\n      transform-origin: left center; /* Scale from the left initially */\n\n    }\n\n    /* Video tab-specific thumbnail styles */\n    &.video-active {\n      img {\n        filter: brightness(40%) blur(5px); /* Only apply blur to image */\n        transform: scale(1.5); /* Enlarge the thumbnail */\n      }\n    }\n\n    .listen-count {\n      margin-top: 8px;\n      color: #fff;\n      text-align: center;\n      font-size: 14px;\n    }\n\n    /* Separate content and buttons for the video tab */\n    .video-content {\n    display:flex;\n      top: 40%; /* Adjust positioning for video content */\n      left: 30%; /* Adjust left positioning for video content */\n      transform: translateY(-50%);\n      z-index: 1;\n      text-align: center;\n      color: white;\n\n      .content-box {\n        .title-with-icon {\n          display: inline-flex;\n          align-items: center;\n          font-weight: 700;\n          font-size: 10px !important; /* Adjust text size for video tab */\n          margin-bottom: 10px;\n          text-align: center;\n\n          img {\n            margin-left: 30px;\n            height: 30px; /* Adjust icon size for video tab */\n          }\n        }\n\n        .playlist-info {\n          display: flex;\n          gap: 10px;\n          margin-top: 5px;\n          font-family: 'Inter';\n          font-size: 12px; /* Adjust font size for video tab */\n          font-weight: 600;\n          align-items: center;\n\n          .song-count {\n            margin-right: 4px;\n          }\n\n          .duration {\n            font-weight: 300;\n          }\n        }\n\n        .uploader-info {\n          display: flex;\n          align-items: center;\n          margin-top: 10px;\n\n          .uploader-name {\n            margin-left: 1px;\n            font-size: 12px;\n            color: white;\n          }\n        }\n      }\n\n      .actions-row {\n        margin-top: 15px;\n        display: flex;\n        gap: 5px;\n        z-index: 1;\n        align-items: center;\n\n        .Music-button, .Video-button, .share-button, .tip-button, .analytics-button {\n          width: 20px; /* Smaller button size for video tab */\n          height: 20px;\n          background-color: rgba(255, 255, 255, 0.2);\n          border-radius: 50%;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n\n          img {\n            width: 15px;\n            height: 15px; /* Smaller icon size for video tab */\n          }\n\n          &:hover {\n            background-color: rgba(255, 255, 255, 0.3);\n          }\n        }\n      }\n    }\n\n    /* Separate content and buttons for the music tab */\n    .music-content {\n      position: absolute;\n      top: 50%; /* Default positioning for music content */\n      left: 10%; /* Default left positioning for music content */\n      transform: translateY(-50%);\n      z-index: 1;\n      text-align: left;\n      color: white;\n\n      .content-box {\n        .title-with-icon {\n          display: inline-flex;\n          align-items: center;\n          font-weight: 700;\n          font-size: 54px; /* Adjust text size for music tab */\n          margin-bottom: 10px;\n\n          img {\n            margin-left: 10px;\n            height: 40px; /* Default icon size for music tab */\n          }\n        }\n\n        .playlist-info {\n          display: flex;\n          gap: 10px;\n          margin-top: 5px;\n          font-family: 'Inter';\n          font-size: 16px; /* Default font size for music tab */\n          font-weight: 600;\n\n          .song-count {\n            margin-right: 4px;\n          }\n\n          .duration {\n            font-weight: 300;\n          }\n        }\n\n        .uploader-info {\n          display: flex;\n          align-items: left;\n          margin-top: 10px;\n\n          .uploader-name {\n            margin-left: 5px;\n            font-size: 12px;\n            color: white;\n          }\n        }\n      }\n\n      .actions-row {\n        margin-top: 20px;\n        display: flex;\n        gap: 10px;\n        z-index: 1;\n        align-items: center;\n\n        .Music-button, .Video-button, .share-button, .tip-button, .analytics-button {\n          width: 40px; /* Default button size for music tab */\n          height: 40px;\n          background-color: rgba(255, 255, 255, 0.2);\n          border-radius: 50%;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n\n          img {\n            width: 20px;\n            height: 20px; /* Default icon size for music tab */\n          }\n\n          &:hover {\n            background-color: rgba(255, 255, 255, 0.3);\n          }\n        }\n      }\n    }\n  }\n\n  .tipper-streamer-section {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    width: 250px;\n    margin-left: auto;\n    margin-top: 0;\n\n    ._playlist_topfive_dropdown_container {\n      margin: 0;\n      background-color: rgba(0, 0, 0, 0.6);\n      backdrop-filter: blur(10px);\n      border-radius: 10px;\n      padding: 10px;\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n      border: 1px solid rgba(255, 255, 255, 0.2);\n      opacity: 0.95;\n      z-index: 1;\n    }\n\n    .tipper-card, .streamer-card {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: 7px;\n      border-radius: 10px;\n      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\n      width: 250px;\n\n      .avatar {\n        width: 30px;\n        height: 30px;\n      }\n\n      .name {\n        color: #fff;\n        cursor: pointer;\n\n        &:hover {\n          text-decoration: underline;\n        }\n      }\n\n      .amount {\n        color: #fff;\n        font-size: 14px;\n        font-weight: 600;\n      }\n    }\n\n    .tipper-streamer-list {\n      max-height: 2%;\n      overflow-y: auto;\n      width: fit-content;\n      align-items: flex-end;\n    }\n\n    .no-data-message {\n      color: #fff;\n      font-size: 14px;\n    }\n  }\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n\n    .tipper-streamer-section {\n      width: 100%;\n      align-items: center;\n    }\n\n    .music-content,\n    .video-content {\n      transform: translateY(-50%);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
